import { useState } from "react";

function SearchBox({ chooseSearchVal }) {
    const [value, setValue] = useState("")
    const inputHandler = (value) => {
        setValue(value)
        chooseSearchVal(value)
    }
    return (
        <div className="bg-purpleMedium02 rounded-full shadow mx-1 flex flex-row-reverse items-center p-1 py-2">
            <input
                className="bg-purpleMedium02 w-64 outline-none mr-2 text-right"
                placeholder="...جستجو"
                value={value}
                onChange={(e) => inputHandler(e.target.value)}
            />
            <img
                src="/image/icon/searchIcon.png"
                className="w-5 ml-1"
            />
        </div>
    )
}
export default SearchBox;